import { Component } from '@angular/core';

@Component({
  selector: 'app-category-result-distribution-table',
  templateUrl: './category-result-distribution-table.component.html',
  styleUrl: './category-result-distribution-table.component.scss'
})
export class CategoryResultDistributionTableComponent {

}
